import React from "react";

const AlertsIcon= () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.83325 10H7.91642L9.16667 8.125L10.8332 11.875L12.0834 10H14.1666" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="15.8333" cy="4.16666" r="2.5" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.5 9.16667V13.3333C17.5 15.6345 15.6345 17.5 13.3333 17.5H6.66667C4.36548 17.5 2.5 15.6345 2.5 13.3333V6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5H10.8333" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
 );
};
export default AlertsIcon;